import { createNamespacedHelpers } from 'vuex'
import { AG } from '../interface/agreement'
import { merge } from 'lodash'

const initState = {
  ag: {},
}

const mutations = {
  [AG.AG](state, paylod) {
    state.ag = merge(state.ag, paylod)
    console.log(state.ag)
  },
  [AG.CLEAR](state) {
    state.ag = {}
  },
}

const { mapMutations, mapState } = createNamespacedHelpers('ag')

export { mapMutations, mapState, AG }

export default {
  namespaced: true,
  state: initState,
  mutations: mutations,
}
